// extracted by mini-css-extract-plugin
export default {"container":"WVJ0qb","description":"sFw4Se","checkboxContainer":"wVft18","alert":"x5Df2b","sectionNotificationContainer":"y5F3ka","labelContainer":"TTfn5A","error":"eqlYw9"};